import * as React from 'react';

export interface SliderProps {
  allowCross?: boolean;
  dataHook?: string;
  className?: string;
  displayMarks?: boolean;
  displayTooltip?: boolean;
  id?: string;
  max?: number;
  min?: number;
  onAfterChange?: (value: number[] | number) => void;
  onBeforeChange?: (value: number[] | number) => void;
  onChange?: (value: number[] | number) => void;
  onBlur?: (value: number[] | number, event?: React.FocusEvent) => void;
  onFocus?: (value: number[] | number, event?: React.FocusEvent) => void;
  rtl?: boolean;
  rangeRef?: React.Ref;
  step?: number;
  pushable?: boolean | number;
  value?: number[] | number;
  enhanceValue?: (value: number) => string;
  disabled?: boolean;
  marks?: { [key: number]: number | string };
  startPoint?: number;
  direction?: 'vertical' | 'horizontal';
  ariaLabelForHandle?: string[] | string;
  ariaLabelledByForHandle?: string[] | string;
  gradientColor?: string;
}

export default class Slider extends React.PureComponent<SliderProps> {}
